<template>
  <div class="app">

     <!-- Modal Component -->
    <b-modal id="modalPrevent"
             ref="modal"
             title="Cambiar contraseña"
             hide-footer
            class="modal-primary" >
<!-- <b-form @submit="onSubmit"> -->
  <b-form @submit.prevent="onSubmit">


<b-form-group id="exampleInputGroup1"
                    label="Contraseña Actual:"
                    label-for=""
                    description="">
                     <b-form-input id=""
                      type="password"
                      v-model="contrasenaactual"
                      required
                      placeholder="">
        </b-form-input>
      </b-form-group>


<b-form-group id="exampleInputGroup1"
                    label="Contraseña:"
                    label-for=""
                    description="">
                     <b-form-input id=""
                      type="password"
                      v-model="contrasena1"
                      required
                      placeholder="">
        </b-form-input>
      </b-form-group>



      <b-form-group id="exampleInputGroup1"
                    label="Repita Contraseña:"
                    label-for=""
                    description="">
                     <b-form-input id=""
                      type="password"
                      v-model="contrasena2"
                      required
                      placeholder="">
        </b-form-input>
      </b-form-group>

<button class="btn btn-primary">Enviar</button>
     </b-form>

    </b-modal>

    <print-pallet>

    </print-pallet>

    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/logos/fsj.jpg" width="130" height="25" alt="CoreUI Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/inicio">Inicio</b-nav-item>
        <b-nav-item class="px-3" exact v-b-modal.modal-print>Imprimir</b-nav-item>
        <b-nav-item class="px-3" @click="goTrazavilidad">Trazabilidad</b-nav-item>
        <b-nav-item class="px-3" href="https://fsj.api.packapp.cl/admin" target="_blank">Configuraciones</b-nav-item>
      </b-navbar-nav>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
          <!--  <b-nav-item class="d-md-down-none">
            <DefaultHeaderDropdownNotif/>
          </b-nav-item>  -->
       <!--  <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdownTasks/>
        </b-nav-item> -->
       <!--  <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdownMssgs/>
        </b-nav-item> -->
       <!--  <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdown/>
        </b-nav-item> -->
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
     <!--  <AsideToggler class="d-none d-lg-block" /> -->
   
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>

    <!--     <DefaultAside/> -->
      </AppAside>

    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://packapp.cl">Packapp</a>
        <span class="ml-1">&copy; 2019 Pecco Systems</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a mailto="jplattus@peccosystems.com">Pecco Systems</a>
      </div>
    </TheFooter>
  </div>




</template>

<script>
/*import nav from '@/_nav'*/
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdown from './DefaultHeaderDropdown'
import DefaultHeaderDropdownNotif from './DefaultHeaderDropdownNotif'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DefaultHeaderDropdownMssgs from './DefaultHeaderDropdownMssgs'
import DefaultHeaderDropdownTasks from './DefaultHeaderDropdownTasks'
import PrintPallet from '../views/printComponent/printPallet.vue'



export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    DefaultHeaderDropdownMssgs,
    DefaultHeaderDropdownNotif,
    DefaultHeaderDropdownTasks,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    PrintPallet
  },
  data () {
    return {
      nav:[],
      contrasenaactual: '',
      contrasena1: '',
      contrasena2: ''
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  methods: {
    goTrazavilidad(){
     this.$router.push("/trazabilidad/search");
    },
    onSubmit() {

      if (this.contrasena1 == "" || this.contrasena2 == "") {

           this.$swal.fire(
            'Falta llenar datos en el formulario',
            '',
            'warning'
          );


      } else {

          if (this.contrasena1 !=  this.contrasena2 ) 
          {

             this.$swal.fire(
              'Las contraseñas deben ser iguales',
              '',
              'warning'
            );

          }else{

       const Data = {
        new_password: this.contrasena1,
        old_password: this.contrasenaactual
     
      };

  
        let padre= this;

      this.$axios
        .put("/menu_view_set/password/change/", Data)
        .then(res => {


          padre.$refs.modal.hide();
       

            padre.$swal.fire(
                          'Contraseña actualizada con éxito',
                          '',
                          'success'
                        );

          this.contrasena1 = "";
          this.contrasena2 = "";
          this.contrasenaactual = "";


        })
          .catch(function (error) {

            padre.$swal.fire(
            error.response.data.detail,
            "",
            "error"
          );
            
      //console.log(error.response.data.detail);
 });



           



          }

   
      }




}
   
  } ,
   mounted(){
 

var MenuListo= [
    {
      name: 'Inicio',
      url: '/inicio',
      icon: 'fa fa-home',
      badge: {
        variant: 'primary',
        text: ''
      }
    },
    {
      title: true,
      name: 'Menu',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    }
  ];

  this.nav = JSON.parse(localStorage.getItem('menu'))


for (var i = 0; i < Object.keys(this.nav).length; i++)
  {

MenuListo.push(JSON.parse(JSON.stringify(this.nav[i])));

  }


    this.nav=MenuListo;



    }
}
</script>
